import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Clock, MessageCircle, Rocket, TrendingUp, ArrowUpWideNarrow} from "lucide-react";
import {useHistory} from "react-router-dom";
import {useBaseCommunity} from "../../store";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const PostSortSheet = styled(({className, sort = "hot", refresh, feedId, feedName, feedKey, community, onClose}) => {

    const baseCommunity = useBaseCommunity();
    const makeLink = (sort) =>
        feedId && `/feed/${feedId}/${feedName}/${sort}` || ((community && community.toLowerCase() !== baseCommunity.toLowerCase())
        ? `/c/${community}/${sort}`
        : `/${sort}`);

    const history = useHistory();
    const handleSort = (selectedSort) => {
        if (selectedSort === sort || selectedSort === "" && sort === "hot") {
            refresh(feedKey);
        } else {
            history.replace(makeLink(selectedSort));
        }
        onClose();
    }

    return (
        <div className={className}>
                <MenuItem onClick={() => handleSort('')}>
                    <MenuItemIcon>
                        <Rocket size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Hot
                    </MenuItemText>
                </MenuItem>
                <MenuItem onClick={() => handleSort('active')}>
                    <MenuItemIcon>
                        <MessageCircle size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Active
                    </MenuItemText>
                </MenuItem>
                <MenuItem onClick={() => handleSort('new')}>
                    <MenuItemIcon>
                        <Clock size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        New
                    </MenuItemText>
                </MenuItem>
                <MenuItem onClick={() => handleSort('rising')}>
                    <MenuItemIcon>
                        <TrendingUp size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Rising
                    </MenuItemText>
                </MenuItem>
                <MenuItem onClick={() => handleSort('top')}>
                    <MenuItemIcon>
                        <ArrowUpWideNarrow size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Top
                    </MenuItemText>
                </MenuItem>
        </div>
    );
})``;

export default PostSortSheet;
